(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creative_typography"] && !Shopify.designMode) return;
  try {
    
  if (typeof CTWords !== 'function') {
    class CTWords extends HTMLElement {
      constructor() {
        super()
        this.init()
        document.addEventListener("shopify:section:load", () => { this.init(); });
      }
      init() {
        this.idx = 0
        this.template = this.querySelector('template').content.cloneNode(true)
        const div = document.createElement('div')
        div.className = 'ct-creative-typography__title'
        div.innerHTML = this.processContent(this.template.querySelector('.ct-creative-typography__html').innerHTML);
        div.append(...this.template.querySelector('.ct-creative-typography__blocks').childNodes)
        this.querySelector('.ct-creative-typography__title')?.remove()
        this.append(div)
      }
      processContent(html) {
        return html.replace(/(<[^>]+>.*?<\/[^>]+>)|(\S+)/g, (match, tag) => {
          this.idx += 1
          if (tag) {
            const newtag = tag.replace(/<([a-zA-Z0-9]+)([^>]*?)>(.*?)<\/\1>/g, (_, inner_tag, attrs, content) =>
              content.split(' ').map((word, i) => {
                if (i != 0) this.idx += 1
                const c = `<span class="ct-creative-typography__word" style="order: ${ this.idx }"><${inner_tag}${attrs}>${word}</${inner_tag}></span>`
                return c
              }).join(' ')
            )
            return newtag
          } else {
            return `<span class="ct-creative-typography__word" style="order: ${ this.idx }">${ match }</span>`
          }
        })
      }
    }
    customElements.define('ct-words', CTWords)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["desktop-collection-filter-drawer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-desktop-collection-filter-drawer]');
  if (!root) return;

  var overlay = root.querySelector('[data-dcf-overlay]');
  var openBtn = root.querySelector('[data-dcf-open]');
  var closeEls = root.querySelectorAll('[data-dcf-close]');
  var drawer = root.querySelector('.dcf-drawer');
  var form = root.querySelector('form[data-faceted-filter-form]');

  function openDrawer() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.documentElement.classList.add('dcf-drawer-open');
  }

  function closeDrawer() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('dcf-drawer-open');
  }

  if (openBtn) {
    openBtn.addEventListener('click', function () {
      if (overlay && overlay.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  if (overlay) {
    overlay.addEventListener('click', function (evt) {
      if (evt.target.hasAttribute('data-dcf-close')) {
        closeDrawer();
      }
    });
  }

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && overlay && overlay.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // ---- AJAX filter apply (no full page reload) ----
  function applyFiltersFromForm(formEl) {
    if (!formEl) return;

    var url = new URL(window.location.href);
    var params = new URLSearchParams();

    var formData = new FormData(formEl);
    formData.forEach(function (value, key) {
      if (value !== '') {
        params.append(key, value);
      }
    });

    url.search = params.toString();

    fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newMain = doc.querySelector('[data-collection-main]');
        var currentMain = document.querySelector('[data-collection-main]');

        if (newMain && currentMain) {
          currentMain.innerHTML = newMain.innerHTML;
        } else {
          var newWrapper = doc.querySelector('.collection-matrix__wrapper');
          var newPagination = doc.querySelector('.container--pagination');
          var currentWrapper = document.querySelector('.collection-matrix__wrapper');
          var currentPagination = document.querySelector('.container--pagination');

          if (newWrapper && currentWrapper) currentWrapper.replaceWith(newWrapper);
          if (newPagination && currentPagination) currentPagination.replaceWith(newPagination);
        }

        window.history.pushState({}, '', url.toString());
        closeDrawer();
      })
      .catch(function (err) {
        console.error('Desktop drawer filters AJAX error', err);
        window.location.href = url.toString();
      });
  }

  if (form) {
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      applyFiltersFromForm(form);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rebuy-tabbed-carousels"] && !Shopify.designMode) return;
  try {
    
  // --- Tabs (kept from the original section, but refreshes carousels after switching) ---
  function tccInitRoot(root) {
    if (!root || root.dataset.tccInit === 'true') return;
    root.dataset.tccInit = 'true';

    const $ = window.jQuery;

    // Ensure theme slider engine runs at least once
    if (window.PXUTheme && window.PXUTheme.jsProduct && typeof window.PXUTheme.jsProduct.relatedProducts === 'function') {
      window.PXUTheme.jsProduct.relatedProducts();
    }

    function getFirstImageTarget(sliderEl) {
      const firstCell = sliderEl.querySelector('.gallery-cell');
      if (!firstCell) return null;
      return (
        firstCell.querySelector('.image__container.product__imageContainer') ||
        firstCell.querySelector('.product__imageContainer') ||
        firstCell.querySelector('.image__container') ||
        firstCell.querySelector('.product-image__wrapper')
      );
    }

    function alignNavToImage(panelEl) {
      if (!panelEl) return;

      const sliderEl = panelEl.querySelector('[data-tcc-slider]');
      if (!sliderEl) return;

      const prevBtn = panelEl.querySelector('[data-tcc-prev]');
      const nextBtn = panelEl.querySelector('[data-tcc-next]');
      if (!prevBtn || !nextBtn) return;

      const imageTarget = getFirstImageTarget(sliderEl);
      if (!imageTarget) return;

      const hostEl = prevBtn.offsetParent || panelEl.querySelector('.js-related-products-slider') || sliderEl;
      if (!hostEl) return;

      const hostRect  = hostEl.getBoundingClientRect();
      const imageRect = imageTarget.getBoundingClientRect();
      const topPx = (imageRect.top - hostRect.top) + (imageRect.height / 2);

      prevBtn.style.top = `${topPx}px`;
      nextBtn.style.top = `${topPx}px`;
    }

    function moveSlider(panelEl, dir) {
      const sliderEl = panelEl.querySelector('[data-tcc-slider]');
      if (!sliderEl) return;

      // Prefer Flickity instance via jQuery (theme uses Flickity in other sections)
      if ($) {
        const $slider = $(sliderEl);
        const inst = $slider.data('flickity');

        if (inst) {
          if (dir === 'next' && typeof inst.next === 'function') { inst.next(); return; }
          if (dir === 'prev' && typeof inst.previous === 'function') { inst.previous(); return; }
        }

        if (typeof $slider.flickity === 'function') {
          try { $slider.flickity(dir === 'next' ? 'next' : 'previous'); return; } catch (e) {}
        }

        // Fallback: click theme’s generated buttons if present
        const fallbackSel = dir === 'next'
          ? '.flickity-prev-next-button.next'
          : '.flickity-prev-next-button.previous';

        const fallbackBtn = sliderEl.querySelector(fallbackSel);
        if (fallbackBtn) fallbackBtn.click();
      }
    }

    // Bind nav buttons once per panel
    root.querySelectorAll('.rb-tabs__panel').forEach(panelEl => {
      if (panelEl.dataset.tccPanelBound === 'true') return;
      panelEl.dataset.tccPanelBound = 'true';

      const prevBtn = panelEl.querySelector('[data-tcc-prev]');
      const nextBtn = panelEl.querySelector('[data-tcc-next]');
      const sliderEl = panelEl.querySelector('[data-tcc-slider]');
      const navAll = panelEl.querySelectorAll('[data-tcc-nav]');

      // Hide nav if <= 1 product
      if (sliderEl) {
        const available = parseInt(sliderEl.getAttribute('data-products-available') || '0', 10);
        if (available <= 1) navAll.forEach(b => b.style.display = 'none');
      }

      if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); moveSlider(panelEl, 'prev'); });
      if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); moveSlider(panelEl, 'next'); });

      // Align after images load
      if (sliderEl) {
        sliderEl.querySelectorAll('img').forEach(img => {
          img.addEventListener('load', () => window.requestAnimationFrame(() => alignNavToImage(panelEl)));
        });
      }
    });

    // Align on resize for the active panel
    function refreshActivePanel() {
      const activePanel = root.querySelector('.rb-tabs__panel:not(.is-hidden)');
      if (!activePanel) return;

      // If Flickity was initialized while hidden, force a resize/reposition
      const sliderEl = activePanel.querySelector('[data-tcc-slider]');
      if ($ && sliderEl) {
        const inst = $(sliderEl).data('flickity');
        if (inst && typeof inst.resize === 'function') inst.resize();
        if (inst && typeof inst.reposition === 'function') inst.reposition();
      }

      window.requestAnimationFrame(() => alignNavToImage(activePanel));
      setTimeout(() => alignNavToImage(activePanel), 120);
      setTimeout(() => alignNavToImage(activePanel), 260);
    }

    window.addEventListener('resize', () => refreshActivePanel());
    refreshActivePanel();

    // --- Click toggling (delegated, same pattern as your existing section) ---
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('#' + root.id + ' .rb-tabs__tab');
      if (!btn) return;

      const tabs   = Array.from(root.querySelectorAll('.rb-tabs__tab'));
      const panels = Array.from(root.querySelectorAll('.rb-tabs__panel'));
      const targetId = btn.dataset.panel;

      tabs.forEach(t => {
        const active = t === btn;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
      });

      panels.forEach(p => {
        p.classList.toggle('is-hidden', p.id !== targetId);
      });

      // Ensure the theme slider engine has a chance to init/resize now that panel is visible
      if (window.PXUTheme && window.PXUTheme.jsProduct && typeof window.PXUTheme.jsProduct.relatedProducts === 'function') {
        window.PXUTheme.jsProduct.relatedProducts();
      }
      refreshActivePanel();
    });

    // Keyboard navigation (arrows, Home/End) — preserved behavior
    document.addEventListener('keydown', function (e) {
      const current = e.target.closest('#' + root.id + ' .rb-tabs__tab');
      if (!current) return;

      const tabs = Array.from(root.querySelectorAll('.rb-tabs__tab'));
      const i = tabs.indexOf(current);
      if (i < 0) return;

      let next;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); next = tabs[(i + 1) % tabs.length]; }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); next = tabs[(i - 1 + tabs.length) % tabs.length]; }
      else if (e.key === 'Home') { e.preventDefault(); next = tabs[0]; }
      else if (e.key === 'End')  { e.preventDefault(); next = tabs[tabs.length - 1]; }

      if (next) { next.focus(); next.click(); }
    });
  }

  // Init all instances on page
  document.querySelectorAll('[data-tcc-root]').forEach(tccInitRoot);

  // Theme editor: re-init when a section is loaded
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target && e.target.querySelector && e.target.querySelector('[data-tcc-root]');
    if (root) tccInitRoot(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-collection-filters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-sticky-collection-filters]');
  if (!root) return;

  var openBtn = root.querySelector('[data-scf-open]');
  var overlay = root.querySelector('[data-scf-overlay]');
  var closeEls = root.querySelectorAll('[data-scf-close]');
  var countBadge = root.querySelector('[data-scf-active-count]');
  var bar = root.querySelector('.scf-bar');
  var form = root.querySelector('form[data-faceted-filter-form]');

  function updateCount() {
    if (!countBadge || !overlay) return;
    var inputs = overlay.querySelectorAll('.faceted-filter-group-display__list-item-input:checked');
    var active = inputs.length;
    countBadge.textContent = active > 0 ? active : '';
  }

  function openOverlay() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    updateCount();
  }

  function closeOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
  }

  if (openBtn) {
    openBtn.addEventListener('click', function () {
      if (overlay && overlay.classList.contains('is-open')) {
        closeOverlay();
      } else {
        openOverlay();
      }
    });
  }

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeOverlay);
  });

  if (overlay) {
    overlay.addEventListener('change', function (evt) {
      if (evt.target.matches('.faceted-filter-group-display__list-item-input')) {
        updateCount();
      }
    });
  }

  // --- AJAX filter apply (no full page reload) ---
  function applyFiltersFromForm(formEl) {
    if (!formEl) return;

    var url = new URL(window.location.href);
    var params = new URLSearchParams();

    var formData = new FormData(formEl);
    formData.forEach(function (value, key) {
      if (value !== '') {
        params.append(key, value);
      }
    });

    url.search = params.toString();

    fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newMain = doc.querySelector('[data-collection-main]');
        var currentMain = document.querySelector('[data-collection-main]');

        if (newMain && currentMain) {
          currentMain.innerHTML = newMain.innerHTML;
        } else {
          // Fallback: swap just grid + pagination
          var newWrapper = doc.querySelector('.collection-matrix__wrapper');
          var newPagination = doc.querySelector('.container--pagination');
          var currentWrapper = document.querySelector('.collection-matrix__wrapper');
          var currentPagination = document.querySelector('.container--pagination');

          if (newWrapper && currentWrapper) currentWrapper.replaceWith(newWrapper);
          if (newPagination && currentPagination) currentPagination.replaceWith(newPagination);
        }

        // Update URL so filters persist on reload/share
        window.history.pushState({}, '', url.toString());

        updateCount();
        closeOverlay();
      })
      .catch(function (err) {
        console.error('Sticky filters AJAX error', err);
        // Fallback to normal navigation if AJAX fails
        window.location.href = url.toString();
      });
  }

  // Intercept form submit (fallback)
  if (form) {
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      applyFiltersFromForm(form);
    });
  }

  // Intercept clicks on ANY "Apply" button inside the overlay BEFORE theme JS
  if (overlay && form) {
    overlay.addEventListener('click', function (evt) {
      var submitButton = evt.target.closest(
        '.faceted-filter-group-display__submit button, ' +
        '.faceted-filter-group-display__submit [type="submit"]'
      );
      if (submitButton) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        applyFiltersFromForm(form);
      }
    }, true); // capture phase so we win
  }

  // --- Smooth "pan down while scrolling, pan up when stop" behaviour ---
  if (bar) {
    var isScrolling = false;
    var scrollTimeout;

    window.addEventListener(
      'scroll',
      function () {
        if (!isScrolling) {
          isScrolling = true;
          bar.classList.add('scf-bar--hidden');
        }

        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          isScrolling = false;
          bar.classList.remove('scf-bar--hidden');
        }, 200);
      },
      { passive: true }
    );
  }
});

  } catch(e) { console.error(e); }
})();
})();
